import { render, staticRenderFns } from "./CleanDesc.vue?vue&type=template&id=52e30d7d&scoped=true&"
import script from "./CleanDesc.vue?vue&type=script&lang=ts&"
export * from "./CleanDesc.vue?vue&type=script&lang=ts&"
import style0 from "./CleanDesc.vue?vue&type=style&index=0&id=52e30d7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e30d7d",
  null
  
)

export default component.exports